// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"c5f68727","389":"03fbc695","520":"4476b107","732":"fda73a07","977":"2cfdb4d4"}[chunkId] + ".chunk.js";
};